import React from 'react';

const Concerns: React.FC = () => {
  const concerns = [
    {
      icon: 'ri-group-line',
      text: '相続した実家が兄弟の共有名義になっているが、意見が合わず売却できない'
    },
    {
      icon: 'ri-phone-off-line',
      text: '共有者の一人と連絡が取れない'
    },
    {
      icon: 'ri-file-list-3-line',
      text: '遺産分割協議が終わっておらず、不動産の名義変更ができていない'
    },
    {
      icon: 'ri-hand-coin-line',
      text: '共有持分だけでも手放したいが、買い手が見つからない'
    },
    {
      icon: 'ri-money-dollar-circle-line',
      text: '固定資産税だけ払い続けている状態をなんとかしたい'
    },
    {
      icon: 'ri-time-line',
      text: '何年も放置していて、どこから手をつければいいかわからない'
    }
  ];

  return (
    <section id="concerns" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">
            こんなお悩みはありませんか？
          </h2>
          <p className="text-xl text-gray-600">
            共有名義・相続未分割の不動産でお困りの方へ
          </p>
        </div>

        <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-6">
          {concerns.map((concern, index) => (
            <div
              key={index}
              className="bg-white rounded-xl p-6 border-2 border-gray-200 hover:border-orange-300 hover:shadow-lg transition-all duration-200"
            >
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center flex-shrink-0 mr-4">
                  <i className={`${concern.icon} text-2xl text-orange-600`}></i>
                </div>
                <p className="text-gray-800 leading-relaxed pt-2">
                  {concern.text}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-xl font-bold text-orange-600 mb-4">
            これらの問題、弁護士なら解決できます
          </p>
          <p className="text-gray-600">
            共有者との交渉、遺産分割協議、法的手続きまで<br />
            一貫してサポートいたします
          </p>
        </div>
      </div>
    </section>
  );
};

export default Concerns;
